import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const storage = getStorage();

// =======================
// 📷 رفع الصور
// =======================
export async function uploadChatImage(chatId, file) {
  const path = `chats/${chatId}/images/${Date.now()}_${file.name}`;
  const storageRef = ref(storage, path);

  await uploadBytes(storageRef, file);

  const url = await getDownloadURL(storageRef);
  return url;
}

// =======================
// 🎥 رفع الفيديو
// =======================
export async function uploadChatVideo(chatId, file) {
  const path = `chats/${chatId}/videos/${Date.now()}_${file.name}`;
  const storageRef = ref(storage, path);

  await uploadBytes(storageRef, file);

  const url = await getDownloadURL(storageRef);
  return url;
}
